import $ from 'jquery';


export class Constant {
    constructor() {

        var lastScrollLeft = 0;
        $(".table-responsive").scroll(function() {
            var documentScrollLeft = $(".table-responsive").scrollLeft();
            //console.log(documentScrollLeft);
            if (documentScrollLeft > 300) {
                $(".fixed-on-scroll").css({
                    "left" : documentScrollLeft,
                    "visibility" : "visible"
                });
            }else{
                $(".fixed-on-scroll").css({
                    "left" : 0,
                    "visibility" : "hidden"
                });
            }
        });

    }
}
